import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        planningGroup: '=',
        context: '='
    },
    template: `
        <div class="heading01" ng-if="vm.canManagePlanningGroups">
            <ul class="actions01">
            <li>
                <a
                    ng-if="!vm.isReadOnly()"
                    class="btn add"
                    ng-click="vm.addEmployee()"
                >{{ 'user.Add more employees' | translate }}</a>
            </li>
            <li>
                <a
                    ng-if="vm.isStatusStopped()"
                    class="btn ico-view"
                    ng-click="vm.updateListOfEmployees()"
                >
                    {{ 'planningGroup.Update list of employees' | translate }}
                </a>
            </li>
        </ul>
        </div>
        <div class="alert alert-info" ng-if="vm.isAutomatic">
            <p ng-bind-html="vm.automaticApgMessage"></p>
        </div>
        <div class="alert alert-danger" ng-if="vm.error">{{ vm.error }}</div>
        <alert-error ng-if="vm.getSaveErrors().length">
            <span
                ng-repeat="error in vm.getSaveErrors() track by $index"
                style="display: block"
                ng-bind-html="error"
            ></span>
        </alert-error>
        <list-no-content ng-if="!vm.list.loading && !vm.list.items.length" show-add-message="true"></list-no-content>
        <div class="well" ng-if="vm.list.loading || vm.list.items.length">
            <pagination-tools list="vm.list" keep-while-loading="true"></pagination-tools>
            <table class="data01" ng-if="vm.list.loading">
                <thead>
                    <tr>
                        <th ng-if="!vm.isReadOnly()"></th>
                        <th>{{ 'planningGroup.Name' | translate }}</th>
                        <th>{{ 'planningGroup.Position' | translate }}</th>
                        <th>{{ 'planningGroup.Previous date completed' | translate }}</th>
                        <th>{{ 'planningGroup.Latest enrollment' | translate }}</th>
                        <th>{{ 'planningGroup.Personal deadline' | translate }}</th>
                        <th> </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td colspan="{{ vm.isReadOnly() ? 6 : 7 }}" class="apg-members-loading">
                            <div class="loader01"></div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="!vm.list.loading">
                <thead>
                    <tr>
                        <th ng-if="!vm.isReadOnly()">
                            <input type="checkbox" ng-model="vm.checked" ng-click="vm.toggleAll()"/>
                        </th>
                        <th>{{ 'planningGroup.Name' | translate }}</th>
                        <th>{{ 'planningGroup.Position' | translate }}</th>
                        <th>{{ 'planningGroup.Previous date completed' | translate }}</th>
                        <th>{{ 'planningGroup.Latest enrollment' | translate }}</th>
                        <th>{{ 'planningGroup.Personal deadline' | translate }}</th>
                        <th> </th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in vm.list.items" ng-class="{ status04: item.isInActive }">
                        <td ng-if="!vm.isReadOnly()">
                            <input type="checkbox"
                                ng-checked="vm.hasEmployeeId(item.userId)"
                                ng-click="$event.stopPropagation();vm.toggleEmployeeId(item.userId)"
                            />
                        </td>
                        <td>{{ item.displayName }}<small ng-if="item.isInActive"> ({{ 'user.Inactive' | translate }})</small></td>
                        <td>
                            <drl-partial-table drls="item.drls"></drl-partial-table>
                        </td>
                        <td>{{ item.previousPassedTime ? vm.MomentService.formatDate(item.previousPassedTime.date) : '-' }}</td>
                        <td>
                            <a ng-if="item.latestEnrollmentStatus && item.activeOccurrenceId"
                                ui-sref="authorized.courses.courses.edit.occurrence.edit.general({ id: vm.planningGroup.courseId, occurrenceId: item.activeOccurrenceId })"
                                target="_blank"
                            >{{ vm.getEnrollmentStatusLabel(item.latestEnrollmentStatus) }}</a>
                            <span ng-if="item.latestEnrollmentStatus && !item.activeOccurrenceId">{{ vm.getEnrollmentStatusLabel(item.latestEnrollmentStatus) }}</span>
                            <span ng-if="!item.latestEnrollmentStatus">-</span>
                        </td>
                        <td ng-bind-html="item.personalDeadline | personalDeadline: item.previousPassedTime:vm.isInfiniteDeadline"></td>
                        <td>
                            <a class="btn delete"
                                ng-if="!vm.isReadOnly()"
                                ng-click="vm.remove(item.userId)"
                            >{{ 'general.Remove' | translate }}</a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <ul class="actions01" ng-if="!vm.list.loading && vm.list.items.length && vm.removeIds.length">
                <li><a class="btn small bordered02" ng-click="vm.remove()">{{ 'general.Remove selected' | translate }}</a></li>
            </ul>
            <pagination list="vm.list"></pagination>
        </div>
        <courses-courses-edit-occurrence-automated-planning-group-footer
            planning-group="vm.planningGroup"
            form="vm.form"
            tab="'employee'"
            context="vm.context"
        />
    `
})
export default class {
    constructor ($state, $translate, $scope, lodash, toastr, DATATABLES, FormFactory, ListFactory, ModalService,
                 PrivilegeService, MomentService, AutomatedPlanningGroupResource, AUTOMATED_PLANNING_GROUP_STATUS_ENUM,
                 AUTOMATED_PLANNING_GROUP_TYPE_ENUM, COURSE_PROGRESS_STATUS_TYPE_ENUM) {
        this.$state = $state;
        this.toastr = toastr;
        this.$translate = $translate;
        this.$scope = $scope;
        this.lodash = lodash;
        this.DATATABLES = DATATABLES;
        this.ListFactory = ListFactory;
        this.ModalService = ModalService;
        this.PrivilegeService = PrivilegeService;
        this.MomentService = MomentService;
        this.AutomatedPlanningGroupResource = AutomatedPlanningGroupResource;
        this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM = AUTOMATED_PLANNING_GROUP_STATUS_ENUM;
        this.AUTOMATED_PLANNING_GROUP_TYPE_ENUM = AUTOMATED_PLANNING_GROUP_TYPE_ENUM;
        this.COURSE_PROGRESS_STATUS_TYPE_ENUM = COURSE_PROGRESS_STATUS_TYPE_ENUM;
        this.form = FormFactory.createFromResource(this.planningGroup, {
            expand: 'planningGroupUsers,course,planningGroupTargetsWithValue.user.drlsWithValue,planningGroupTargetsWithValue.courseTarget.employee.drlsWithValue,targetRulesets.conditions'
        });
    }

    $onInit () {
        this.isInfiniteDeadline = this.planningGroup.course.expirationMonths === null;
        this.list = this.ListFactory.createWithPagination(
            this.AutomatedPlanningGroupResource.users.bind(this.AutomatedPlanningGroupResource)
        );
        this.canManagePlanningGroups = this.PrivilegeService.canManageAutomatedPlanningGroups();
        this.isAutomatic = this.planningGroup.type === this.AUTOMATED_PLANNING_GROUP_TYPE_ENUM.KEYS.AUTOMATIC;
        this.list.pagination.perPage = 25;
        this.fetch();

        this.automaticApgMessage = this.$translate.instant('planningGroup.you_have_defined_automatic_type_notice');
        this.$scope.$on('employee-list:update', () => {
            this.fetch();
        });
        this.$scope.$on('employee-list:refresh', () => {
            this.refreshQuietly();
        });
    }

    fetch () {
        this.list.fetch({ planningGroupId: this.planningGroup.id }).then(() => {
            this.removeIds = [];
            this.checked = false;
        });
    }
    /**
     * Shows the latest enrollments once an enrollment run has ended. The members of the page stay the same, so
     * their rows are updated in place: the table keeps its rows and no loader is shown. A page that shows other
     * members by now is loaded as usual.
     */
    refreshQuietly () {
        if (this.list.loading) {
            return;
        }
        this.AutomatedPlanningGroupResource.users(this.list.lastQuery).$promise.then((items) => {
            const rowsByUserId = this.lodash.keyBy(this.list.items, 'userId');
            const isSamePage = items.length === this.list.items.length
                && items.every(item => rowsByUserId[item.userId]);
            if (!isSamePage) {
                this.fetch();
                return;
            }
            items.forEach((item) => {
                const row = rowsByUserId[item.userId];
                row.latestEnrollmentStatus = item.latestEnrollmentStatus;
                row.activeOccurrenceId = item.activeOccurrenceId;
                row.personalDeadline = item.personalDeadline;
                row.previousPassedTime = item.previousPassedTime;
            });
        });
    }

    toggleAll () {
        this.removeIds = this.checked ? this.list.items.map(item => item.userId) : [];
    }

    hasEmployeeId (id) {
        return this.lodash.includes(this.removeIds, id);
    }

    toggleEmployeeId (id) {
        if (this.hasEmployeeId(id)) {
            this.lodash.pull(this.removeIds, id);
            this.checked = false;
        }
        else {
            this.removeIds.push(id);
        }
    }

    /**
     * Every message a refused save produced that this step can show, see the targets step; refusals
     * about the group's sites or people go to the general tab with the footer
     *
     * @returns {string[]}
     */
    getSaveErrors () {
        return [
            this.form.errors.courseVersionId,
            this.form.errors.trainings
        ].filter(Boolean);
    }

    addEmployee () {
        const { planningGroup } = this;
        return this.ModalService.open({
            size: 'large',
            template: `
                <modals-courses-occurrence-automated-planning-group-employee
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    planning-group="vm.planningGroup"
                />`,
            controller ($uibModalInstance) {
                this.planningGroup = planningGroup;
                this.$uibModalInstance = $uibModalInstance;
            }
        }).then(() => this.handleEmployeeListChange());
    }

    remove (id = null) {
        if (id) {
            this.removeIds = [id];
        }

        const message = this.$translate.instant('planningGroup.remove_users_confirm_message');
        this.ModalService.confirm(message, 'medium').then(() => {
            this.saving = true;
            this.AutomatedPlanningGroupResource.removeUsers({ id: this.planningGroup.id }, { ids: this.removeIds }).$promise
                .then(() => {
                    this.saving = false;
                    this.handleEmployeeListChange();
                })
            ;
        });
    }

    updateListOfEmployees () {
        const message = this.$translate.instant('planningGroup.Update list of employees confirmation');
        this.ModalService.confirm(message, 'medium').then(() => {
            this.saving = true;
            this.form.model.forceDetectStoppedApg = true;
            this.form.model.renewEmployeeList = true;
            this.form.save()
                .then(() => {
                    this.saving = false;
                    this.form.saved = false;
                    this.toastr.success(this.$translate.instant('general.Changes saved'));
                    this.handleSuccess();
                });
        });
    }

    handleEmployeeListChange () {
        this.form.cleanErrors();
        this.handleSuccess();
    }

    handleSuccess () {
        this.fetch();
        this.reloadPlanningGroup();
    }

    reloadPlanningGroup () {
        this.AutomatedPlanningGroupResource.get({
            id: this.planningGroup.id,
            expand: 'planningGroupUsers,course,planningGroupTargetsWithValue.user.drlsWithValue,planningGroupTargetsWithValue.courseTarget.employee.drlsWithValue,targetRulesets.conditions'
        }).$promise
            .then(model => this.$scope.$emit('planning-group:update', model));
    }

    isReadOnly () {
        return !this.canManagePlanningGroups || this.isAutomatic
            || this.planningGroup.status === this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.CANCELLED;
    }

    /**
     * @param {string} status participation status of the latest enrollment of a member
     * @returns {string}
     */
    getEnrollmentStatusLabel (status) {
        return this.COURSE_PROGRESS_STATUS_TYPE_ENUM.LABELS[status] || status;
    }

    isStatusStopped () {
        return this.planningGroup.status === this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.STOPPED;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/automated/planningGroup/steps/employee/index.js